var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-time"},[_c('span',[_vm._v("\n        "+_vm._s(_vm._f("formatDateTime")(_vm.now,'ddmmyyyy'))+"\n    ")]),_vm._v(" "),_c('span',[_vm._v("\n        "+_vm._s(_vm._f("formatDateTime")(_vm.now,'time'))+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c01d894","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/modules/shared/components/DateTimeDisplay.vue
// module id = 1826
// module chunks = 0